import React from 'react';
import { ActivityContainer, Title } from './OpenPanel.styled';
import OpenDates from '../OpenDates/OpenDates';

const OpenPanel = ({ contactOpenActivity }) => {
  return (
    <ActivityContainer>
      <Title>Open Activity</Title>
      {contactOpenActivity.map(activity => (
        <OpenDates key={activity.email} openEvent={activity} />
      ))}
    </ActivityContainer>
  );
};

export default OpenPanel;
